import { kebabCase } from "../../utils";
export function getItemId(baseId, value, id) {
  return id || "".concat(baseId, "-").concat(kebabCase(value));
}
export * from "./useTypeaheadShortcut";
//# sourceMappingURL=index.js.map